module.exports = __webpack_public_path__ + "img/bg.eb19fd3f.jpg";